import angular from 'angular';
import NewProductsComponent from './new-products.component';

let NewProductsModule = angular.module('catalog.newProducts', [])
  .component('newProducts', NewProductsComponent);

export default NewProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/new-products/new-products.js
 **/